<mp-single-selection-group
  [options]="filterOptions()"
  [filterName]="filterName()"
  [icon]="icon()"
  [showSelectionInfo]="true"
  [selectedValue]="selectedValue()"
  (selectedValueChange)="onSelectionChanged($event)"
  (optionSelect)="onOptionSelected($event)"
  [isExpanded]="isExpanded"
  (isExpandedChange)="onExpandedChange($event)"
/>
